<template>
  <a-form-model-item :label="field.label" :label-col="fieldLabelCol" :wrapper-col="fieldWrapperCol">
    <!-- 服务名称 -->
    <a-input v-if="field.key === 'name'" :value="form.name" allow-clear placeholder="服务名称" @input="handleInputChange('name', $event)" />
    <!-- 服务类型 -->
    <a-select v-else-if="field.key === 'service_type'" :value="form.service_type" allow-clear placeholder="服务类型" @change="handleSelectChange('service_type', $event)">
      <a-select-option :value="1">后端</a-select-option>
      <a-select-option :value="2">前端</a-select-option>
      <a-select-option :value="3">Apple</a-select-option>
      <a-select-option :value="4">Android</a-select-option>
    </a-select>
    <!-- 负责人 -->
    <user-select v-else-if="field.key === 'owner'" :value="form.owner" allow-clear show-search show-all placeholder="负责人" @change="handleSelectChange('owner', $event)" />
    <!-- 所属项目 -->
    <a-select v-else-if="field.key === 'project_id'" :value="form.project_id" show-search placeholder="所属项目" allow-clear @change="handleSelectChange('project_id', $event)">
      <a-select-option v-for="item in options.projectOptions" :key="item.project_id" :value="item.project_id">
        {{ item.name }}
      </a-select-option>
    </a-select>
    <!-- 自动发布 -->
    <a-select v-else-if="field.key === 'auto_deploy'" :value="form.auto_deploy" allow-clear placeholder="自动发布" @change="handleSelectChange('auto_deploy', $event)">
      <a-select-option :value="1">是</a-select-option>
      <a-select-option :value="0">否</a-select-option>
    </a-select>
    <!-- 自助发布 -->
    <a-select v-else-if="field.key === 'self_deploy'" :value="form.self_deploy" allow-clear placeholder="自助发布" @change="handleSelectChange('self_deploy', $event)">
      <a-select-option :value="1">是</a-select-option>
      <a-select-option :value="0">否</a-select-option>
    </a-select>
    <!-- 专项测试 -->
    <a-select v-else-if="field.key === 'special_test'" :value="form.special_test" allow-clear placeholder="专项测试" @change="handleSelectChange('special_test', $event)">
      <a-select-option v-for="(item, key) in options.serviceSpecialTests" :key="key" :value="item.value">
        {{ item.label }}
      </a-select-option>
    </a-select>
    <!-- 语言 -->
    <a-input v-else-if="field.key === 'language'" :value="form.language" allow-clear placeholder="语言" @input="handleInputChange('language', $event)" />
    <!-- 发布策略 -->
    <a-select v-else-if="field.key === 'strategy'" :value="form.strategy" mode="multiple" allow-clear placeholder="发布策略" @change="handleSelectChange('strategy', $event)">
      <a-select-option v-for="(item, key) in options.serviceStrategys" :key="key" :value="item.name">
        <a-tag :color="item.color">{{ item.name }}</a-tag>
      </a-select-option>
    </a-select>
  </a-form-model-item>
</template>

<script>
import { debounce } from 'lodash';

import UserSelect from '@/components/User/UserSelect';

export default {
  name: 'ServiceFilterFormItem',
  components: { UserSelect },
  props: {
    field: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true,
      default: () => ({
        serviceSpecialTests: [],
        serviceStrategys: [],
        projectOptions: []
      })
    },
    reset: {
      type: Boolean,
      default: false
    },
    labelCol: {
      type: Object,
      default: null
    },
    wrapperCol: {
      type: Object,
      default: null
    }
  },
  computed: {
    fieldLabelCol() {
      return this.labelCol === null ? { span: this.field.labelSpan || 6 } : this.labelCol;
    },
    fieldWrapperCol() {
      return this.wrapperCol === null ? { span: this.field.wrapperSpan || 18 } : this.wrapperCol;
    }
  },
  watch: {
    reset(newVal) {
      if (newVal) {
        // 重置处理
      }
    }
  },
  methods: {
    handleInputChange(key, event) {
      const value = event.target.value;
      this.debouncedInputChange(key, value);
    },

    handleSelectChange(key, value) {
      this.$emit('change', { key, value });
    },

    // 防抖处理输入框变化
    debouncedInputChange: debounce(function (key, value) {
      this.$emit('change', { key, value });
    }, 500)
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 0px;

  .ant-form-item-label {
    text-align: right;
    color: #495057;
    padding-right: 8px;
  }
}

:deep(.ant-input),
:deep(.ant-select),
:deep(.ant-picker),
:deep(.ant-tree-select),
:deep(.ant-calendar-picker) {
  width: 100%;
}
</style>
